import {
  createFetchActionForNamespace,
  createReducer,
  createFetchReducers,
  createFetchSelectors
} from 'utils/reducers';

const createFetchAction = createFetchActionForNamespace('reporting/looker');

export const fetchLookerRevenueUrl = createFetchAction({
  name: 'FETCH_LOOKER_REVENUE_URL',
  initialAction: ({locationRef}) => ({
    payload: {locationRef}
  }),
  stateKey: 'lookerUrl',
  defaultStateValue: []
});

export const selectLookerRevenueUrl = createFetchSelectors(
  fetchLookerRevenueUrl
).data;

export const selectLookerRevenueUrlIsLoading = createFetchSelectors(
  fetchLookerRevenueUrl
).isLoading;

const initialState = {};

const fetchReducers = createReducer(initialState, {
  ...createFetchReducers(fetchLookerRevenueUrl)
});

const reducer = (state = {}, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;

export {default as lookerRevenueReportingSaga} from './saga';
